<template>
  <WrapperCell
      code="benefit_prize"
      :icon="ICONS.promocode"
      @open="onClick"
      label="Приз"
      :active="active"
      :mode="mode"
  >
    <div class="s-font-3xs">
      {{ userPrizeElement?.NAME }}
    </div>
  </WrapperCell>
</template>

<script lang="ts" setup>

import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import {storeToRefs} from "pinia";
import {ICONS} from "@/assets/icons";
import WrapperCell from "@/components/Shop/VOrder/ui/Section/Wrapper/WrapperCell.vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useFortuneStore} from "@/modules/fortune/store/fortune";

const vorderState = useVorderState()
const fortuneStore = useFortuneStore()

const {attrs, coupon} = storeToRefs(vorderState)
const {userPrizeElement, userPrizeGiftProduct} = storeToRefs(fortuneStore)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})

</script>
<style scoped>

</style>
